import { tw } from "@careinfo/tailwind";
import React from "react";

const ChargeTableSkeleton = () => {
  return (
    <>
      <div className={tw`w-52 h-8 bg-gray-200 animate-pulse`}></div>
      <table className={tw`my-2 w-full `}>
        <thead className={tw`text-justify w-full`}>
          <tr className={tw`h-10 w-full rounded-xl animate-pulse space-x-2`}>
            {Array.from({ length: 7 }).map((_, index) => {
              return (
                <td
                  key={index}
                  className={tw`h-6 w-30  bg-gray-200  animate-pulse`}
                ></td>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 7 }).map((_, index) => {
            return (
              <tr
                key={index}
                className={tw` w-full  bg-gray-200  animate-pulse`}
              >
                {Array.from({ length: 7 }).map((_, index) => {
                  return (
                    <td
                      key={index}
                      className={tw`h-10 w-30  bg-gray-200 animate-pulse`}
                    ></td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};

export default ChargeTableSkeleton;
